class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

 
//nav swiper
class NavSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="nav-swiper-"]');
    if (!this.slider) return;
    this.initSwiper();
  }

  initSwiper() {
      return new Swiper(this.slider, {
        loop: false,
        slidesPerView: 4,
        spaceBetween: 40,
          // Navigation arrows
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          }
      });
  }
}
customElements.define('nav-swiper', NavSlider);


class CollectionSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="swiper-"]');
      if (!this.slider) return;
      this.initSwiper();
    }
  
    initSwiper() {
        return new Swiper(this.slider, {
            loop: true,
            slidesPerView: 1.3,
            spaceBetween: 40,
            mousewheel: true, 
            mousewheel: {
                forceToAxis: true,
            },                          
            // Responsive breakpoints
            breakpoints: {
            
                // when window width is >= 480px
                480: {
                slidesPerView: 1.5,
                spaceBetween: 40
                },
                // when window width is >= 768px
                768: {
                slidesPerView: 2.75,
                spaceBetween: 40
                },
                // when window width is >= 768px
                1050: {
                slidesPerView: 3.75,
                spaceBetween: 40
                }
            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    }
  
  }
  
  customElements.define('collection-swiper', CollectionSlider);
// featured collections grid
class FeaturedCollectionsGrid extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="swiper-"]');
    if (!this.slider) return;
    this.initSwiper();
  }

  initSwiper() {
      return new Swiper(this.slider, {
        loop: false,
        slidesPerView: 1.3,
        spaceBetween: 20,
        mousewheel: true,
        mousewheel: {
          forceToAxis: true,
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 480px
          480: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          // when window width is >= 768px
          768: {
            slidesPerView: 2.75,
            spaceBetween: 20,
          },
          // when window width is >= 768px
          1050: {
            slidesPerView: 3.75,
            spaceBetween: 40,
          },
        },
    
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });
  }

}

customElements.define('featured-collections-grid', FeaturedCollectionsGrid);


  //reviews swiper
  class ReviewsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="swiper-"]');  
      this.pagination = this.slider.getAttribute('data-pagination'); 
      if (!this.slider) return;
      this.initSwiper();
    }
  
    initSwiper() {
      if(this.pagination == 'dots'){
        return new Swiper(this.slider, {
          // Optional parameters
        
          loop: true,

            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
                                                
            },
            mousewheel: true, 
            mousewheel: {
              forceToAxis: true,
            },
            // Responsive breakpoints
            breakpoints: {
            
              
              // when window width is >= 768px
              768: {
                slidesPerView: 1,
                spaceBetween: 0
              }
            }
          
        });
      }else {
        return new Swiper(this.slider, {
          // Optional parameters
        
          loop: true,
          mousewheel: true, 
          mousewheel: {
            forceToAxis: true,
          },
          slidesPerView: 1.18,
          spaceBetween: 0,
          
          // Navigation arrows
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }, 
          // Responsive breakpoints
          breakpoints: {                 
            // when window width is >= 768px
            768: {
              slidesPerView: 1,
              spaceBetween: 0
            }
          }
          
        });
      }
        
      
    }
  
  }
  customElements.define('reviews-swiper', ReviewsSlider);

  class offsetSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="swiper-"]'); 
      if (!this.slider) return;
      this.initSwiper();
    }
  
    initSwiper() {
        return new Swiper(this.slider, { 
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',                                  
          }    
        });
    }
  }
  customElements.define('offset-swiper', offsetSlider);

  //product images
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="swiper-"]'); 
      this.sliderThumbs = this.querySelector('[id^="thumbs-swiper-"]') 
      if (!this.slider) return;
      this.initSwiper();
    }
  
    initSwiper() {
      var swiper2 = new Swiper(this.sliderThumbs, {
        spaceBetween: -1,
        slidesPerView: 5.25,
        freeMode:true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        mousewheel: true,
        mousewheel: {
          forceToAxis: true,
        }
      });
      var swiperPDP = new Swiper(this.slider, {
                // Optional parameters
                watchSlidesProgress: true,
                loop: false,
                mousewheel: true, 
                mousewheel: {
                  forceToAxis: true,
                },
                slidesPerView: 1,
                spaceBetween: 0,
                thumbs: {
                  swiper: swiper2,
                }
                
        });
        swiperPDP.on("slideChangeTransitionStart", function () {
          swiper2.slideTo(swiperPDP.activeIndex);
        });
        swiper2.on("transitionStart", function () {
          swiperPDP.slideTo(swiper2.activeIndex);
        });
    }
  }
  customElements.define('product-photo-swiper', ProductSlider);

  class MiniSlider extends HTMLElement {
    constructor() {
      super();
      this.main_images = this.closest('.main-content').querySelector('.product-image-wrap');
      this.slider = this.querySelector('[id^="mini-swiper-"]');  
      if (!this.slider) return;
      this.scrollCheck();
      this.initSwiper();
    }
    scrollCheck(){
      const content = this.main_images
      document.addEventListener("scroll", (e) => {

        var scrolled = document.scrollingElement.scrollTop;
        var position = content.offsetTop;
        var height = content.offsetHeight;

        if(scrolled > position + height - 40 ){
          this.parentNode.classList.add(
            'show');
          } else {
            if (this.parentNode.classList.contains('show')){
              this.parentNode.classList.remove('show');
            }
          }
      });
    }
    initSwiper() {
        return new Swiper(this.slider, {
                loop: false,
                mousewheel: true, 
                mousewheel: {
                  forceToAxis: true,
                },
                slidesPerView: 1,
                spaceBetween: 4,
                centeredSlides: true,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },  
                pagination: {
                  el: '.swiper-pagination',
                  type: 'bullets',
                },
                breakpoints: {                 
                  768: {
                    slidesPerView: 1,
                    spaceBetween: 0
                  }
                }
                
        });
    }
  
  }
  customElements.define('mini-slider', MiniSlider);

  class ProductGridItemSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="product-item-swiper-"]'); 
      this.grid_content = this.closest('.grid-product__content');
      this.grid_item = this.closest('.grid__item');
      if (!this.slider) return;
      this.initSwiper();
      this.initSwatches();
    }
    initSwiper() {
      var progress = this.grid_item.querySelector('.collection-product__images-loader');
      var swiperGridItem = new Swiper(this.slider, {
                // Optional parameters
                watchSlidesProgress: true,
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                disableOnInteraction: false, 
                effect: 'fade',
                observer: true,
                autoplay: {
                  delay: 1000,
                  stopOnLastSlide: true
                },
                speed: 1,
                fadeEffect: {
                    crossFade: true
                }
        });
        swiperGridItem.on('slideChangeTransitionEnd', function () {
          //console.log('slide changed');
          var percent = (swiperGridItem.activeIndex) / (swiperGridItem.slides.length - 1);
          var width = percent * 100 + '%';
          //console.log(width);
          progress.style.width = width;
        });
        swiperGridItem.autoplay.stop();
        this.grid_content.addEventListener("mouseover", (function() {
          swiperGridItem.autoplay.start()
        })), this.grid_content.addEventListener("mouseout", (function() {
          swiperGridItem.autoplay.stop()
          //swiperGridItem.slideTo(0,1)
          //progress.style.width = '0px';
        })); 

        this.swatches = this.grid_item.querySelectorAll('.color-swatch--custom');
        let grid_item = this.grid_item;
          for (let i = 0; i < this.swatches.length; i++) {
            this.swatches[i].addEventListener('click', function (e) { 
              //console.log('swap content test')
              // we need to disable all active states on swatches 
                const activeSwatch = grid_item.querySelector('.color-swatch--custom.active')
                const varUrl = e.currentTarget.dataset.variantUrl
                const varAvailable = e.currentTarget.dataset.available
                const varPrice = e.currentTarget.dataset.price
                const varCompPrice = e.currentTarget.dataset.compareAtPrice
                const varId = e.currentTarget.dataset.variantId
                const varHandle = e.currentTarget.dataset.variantHandle
                const varSale = e.currentTarget.dataset.onSale
                const priceItem = grid_item.querySelector('.grid-product__price')
                const thisGallery = grid_item.querySelector('product-grid-item-swiper .swiper-wrapper')
                activeSwatch.classList.remove('active')
                // then we add active state to clicked item
                e.currentTarget.classList.add('active')
                // then we swap the image for the 'cover'
                var new_img = e.currentTarget.dataset.variantImage
                var new_srcset = e.currentTarget.dataset.variantSrcset
                grid_item.querySelector('.grid-product__image').setAttribute('src', new_img)
                grid_item.querySelector('.grid-product__image').setAttribute('srcset', new_srcset)

                // then we swap the links out so they link to this variant
                grid_item.querySelectorAll('a').forEach((link) => {
                  link.href = varUrl;
                });
                //then we do the color label
                grid_item.querySelector('.current_color').innerHTML = e.currentTarget.dataset.color
                // then we swap the price / sold out text 
                if (varAvailable){
                  if ( varSale == 'true' ) {
                    priceItem.innerHTML = '<span class="visually-hidden">Regular price</span> <span class="visually-hidden">Sale price</span> <span class="grid-product__price--original">'+varCompPrice+'<br></span><span class="on_sale_price"><span>'+varPrice+'</span></span>';
                  }else{
                    priceItem.innerHTML = '<span data-wpd-variant-compare-at-price="'+varCompPrice+'" data-wpd-variant-price="'+varPrice+'" data-wpd-variant-id="'+varId+'" data-wpd-product-handle="'+varHandle+'">'+varPrice+'</span>';
                  }
                } else {
                  priceItem.innerHTML = '<span class="sold-out">Sold Out</span>';
                }
                // then we swap the content for the swiper based on the variant url fetch content (not sure if I am doing a separate mini slider or just one on the pdp... where should the content for this come from?)
                fetch(varUrl)
                  .then((response) => response.text())
                  .then((responseText) => {
                      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                      const miniImageGallery = responseHTML.querySelector('mini-slider .swiper-wrapper');
                      
                      HTMLUpdateUtility.setInnerHTML(thisGallery, miniImageGallery.innerHTML);
                      progress.style.width = '0px';
                      swiperGridItem.update()
                      swiperGridItem.slideTo(0,0)
                      
                      //HTMLUpdateUtility.setInnerHTML(this.miniImages, miniImageGallery.outerHTML);    
                  })
            })
          }
    }
    initSwatches() {
      
        }
  
  }
  customElements.define('product-grid-item-swiper', ProductGridItemSlider);

  class mobileNavTabs extends HTMLElement {
    constructor() {
      super();
      this.navItems = this.querySelectorAll('.mobile-nav__link--button.collapsible-trigger-custom');
      if (!this.navItems) return;
      this.initItems();
    }
  
    initItems() {
        let container = this;
        
        for (let i = 0; i < this.navItems.length; i++) {
          this.navItems[i].addEventListener('click', function (e) {
            const activeSwatch = container.querySelector('.mobile-nav__link--button.collapsible-trigger-custom.is-open')
            const activeItem = container.querySelector('.subnav_ya.is-open')
            // remove stuff from current item
            activeSwatch.classList.remove('is-open')
            activeSwatch.setAttribute('aria-open', 'false')
            activeSwatch.querySelector('span').setAttribute('data-active', 'false')
            activeItem.classList.remove('is-open')
            activeItem.style.height = "0"
            //add to new item
            const id = e.currentTarget.getAttribute('aria-controls')
            const match = document.querySelector('#'+id)
            e.currentTarget.classList.add('is-open')
            e.currentTarget.setAttribute('aria-open', 'true')
            e.currentTarget.querySelector('span').setAttribute('data-active', 'true')
            //activate matching id
            match.classList.add('is-open')
            match.style.height = "auto"
          });
      } 
    }
  
  }
  customElements.define('custom-mobile-nav', mobileNavTabs);

  class mapMarkers extends HTMLElement {
    constructor() {
      super();
      this.markers = this.querySelectorAll('.map-marker');
      if (!this.markers) return;
      this.initItems();
    }
  
    initItems() {
        let container = this;
        
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].addEventListener('click', function (e) {
            const activeMarker = container.querySelector('.map-marker.active')

            const imageContainer = container.querySelector('#active-img')
            const titleContainer = container.querySelector('#active-title')
            const locContainer = container.querySelector('#active-loc')
            const textContainer = container.querySelector('#active-text')


            const image = e.currentTarget.dataset.image
            const title = e.currentTarget.dataset.title
            const loc = e.currentTarget.dataset.location
            const text = e.currentTarget.dataset.text
            
            // remove stuff from current item
            activeMarker.classList.remove('active')
            e.currentTarget.classList.add('active')
            //set content to ids
            imageContainer.setAttribute('srcset', image)            
            imageContainer.src = image
            titleContainer.innerHTML = title
            locContainer.innerHTML = loc
            textContainer.innerHTML = text
            
          });
      } 
    }
  
  }
  customElements.define('map-markers', mapMarkers);

  class CustomFAQ extends HTMLElement {
    constructor() {
      super();
      this.searchInput = null;
      this.articles = [];
      this.categories = [];
      this.resultsDropdown = null;
    }
  
    connectedCallback() {
      // Initialize after the element is attached to the DOM
      this.initFAQ();
    }
  
    initFAQ() {
      // Select relevant elements
      this.searchInput = this.querySelector('#fillSearch');
      this.resultsDropdown = this.querySelector('.ui-autocomplete');
      this.articles = Array.from(this.querySelectorAll('.faq-article'));
      this.categories = Array.from(this.querySelectorAll('.faq-cat'));
  
      // Build searchable data
      const searchableData = this.articles.map((article) => ({
        title: article.querySelector('.title h5').innerText,
        category: article.dataset.category,
        id: article.id,
      }));
  
      // Bind event listeners
      this.searchInput.addEventListener('input', (e) => {
        this.showSearchResults(e.target.value, searchableData);
      });
  
      this.categories.forEach((cat) =>
        cat.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleCategoryClick(cat);
        })
      );
  
      this.articles.forEach((article) =>
        article.querySelector('.title').addEventListener('click', () => {
          article.classList.toggle('open');
        })
      );
  
      // Show initial active category
      const activeCategory = this.querySelector('.faq-cat.active')?.dataset.category;
      this.updateVisibleArticles(activeCategory);
    }
  
    showSearchResults(query, searchableData) {
      this.resultsDropdown.innerHTML = ''; // Clear previous results
  
      if (!query) {
        this.resultsDropdown.style.display = 'none';
        return;
      }
  
      const filteredResults = searchableData.filter((item) =>
        item.title.toLowerCase().includes(query.toLowerCase())
      );
  
      if (filteredResults.length === 0) {
        this.resultsDropdown.innerHTML = `<div>No results found</div>`;
        this.resultsDropdown.style.display = 'block';
        return;
      }
  
      filteredResults.forEach((item) => {
        const resultItem = document.createElement('div');
        resultItem.classList.add('result-item');
        resultItem.textContent = item.title;
        resultItem.dataset.url = `#${item.id}`;
        resultItem.dataset.category = item.category;
  
        resultItem.addEventListener('click', () => {
          this.navigateToArticle(item.category, item.id);
        });
  
        this.resultsDropdown.appendChild(resultItem);
      });
  
      this.resultsDropdown.style.display = 'block';
    }
  
    navigateToArticle(category, id) {
      this.updateVisibleArticles(category);
      const targetArticle = this.querySelector(`#${id}`);
  
      if (targetArticle) {
        window.scrollTo({
          top: targetArticle.offsetTop - 116,
          behavior: 'smooth',
        });
      }
  
      this.searchInput.value = '';
      this.resultsDropdown.style.display = 'none';
    }
  
    handleCategoryClick(categoryElement) {
      const category = categoryElement.dataset.category;
  
      this.categories.forEach((cat) =>
        cat.classList.toggle('active', cat === categoryElement)
      );
  
      this.updateVisibleArticles(category);
      window.location.hash = category;
    }
  
    updateVisibleArticles(category) {
      this.articles.forEach((article) => {
        article.classList.toggle('visible', article.dataset.category === category);
      });
    }
  }
  
  customElements.define('custom-faq', CustomFAQ);

  
  let elements = document.querySelectorAll('.js-drawer-open-info');
 
  elements.forEach((item) => {
      item.addEventListener('click', function(item){
        var tabToActivate = item.currentTarget.getAttribute('data-infolink-toggle')
      var drawer = document.getElementById('InfoDrawer')
      var matchingTab = drawer.querySelector('.tabs [value="'+tabToActivate+'"]')
      matchingTab.checked = true;
      console.log(tabToActivate)

      })
  });
  


  function hideUnavailableOptions(product) {
    if (!product) return;
    var optionsToCheck = product.options_with_values.filter(function(option) {
      return option.position !== 1;
    });
    var selected_variant = _product.selected_variant;
    //console.log(selected_variant);
    
    optionsToCheck.forEach(function(option) {
      option.values.forEach(function(value) {
        var related_variants = product.variants.filter(function(v) {
          if (option.position == 2) {
            return v.option1 == selected_variant.option1 && v.option2 == value && v.option3 == selected_variant.option3;
          }
          else {
            return v.option1 == selected_variant.option1 && v.option2 == selected_variant.option2 && v.option3 == value;
          }
        });
        
        var $swatch = $('.variant-input[data-value="' + value + '"][data-index="option' + option.position + '"]');
        //console.log(value, $swatch, related_variants);
        $swatch.toggleClass('hide', related_variants.length == 0);
      });
    });
    
    $('.add-to-cart').toggleClass('hide', !selected_variant.available);
  }

  
  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductOptions', () => ({
      options: [],
      variants: [],
      init() {
        this.InitWatchers();
        this.InitSelf();
      },
      InitSelf() {
        let am = this;
        am.options = JSON.parse(am.$el.dataset.options);
        am.variants = JSON.parse(am.$el.dataset.variants);
        am.UpdateOptions();
      },
      InitWatchers() {
        let am = this;
        document.addEventListener('variant:change', am.UpdateOptions.bind(am));
      },
      UpdateOptions() {
        let am = this;
        let selected_values = [...am.$el.querySelectorAll('[data-variant-input]:checked')].map($item => $item.value);

        // show-hide options based on availability
        am.$el.querySelectorAll('[data-variant-input]').forEach(($item) => {
          let option_index0 = $item.dataset.optionIndex0;
          if (option_index0 == 0) return;

          let match_values = [...selected_values];
          let is_LastOption = option_index0 == selected_values.length - 1;
          if (is_LastOption) {
            match_values[option_index0] = $item.value;
            let matching_variants = am.variants.filter(variant => variant.options.join('~') === match_values.join('~'));
            // console.log(match_values, matching_variants, $item.closest('.variant-input'))
            $item.closest('.variant-input').classList.toggle('visually-hidden', matching_variants.length == 0);  
          }
          else {
            match_values = match_values.filter((value, index) => index < option_index0);
            match_values[option_index0] = $item.value;
            let matching_variants = am.variants.filter(variant => variant.options.join('~').indexOf(match_values.join('~')) !== -1);
            // console.log(match_values, matching_variants, $item.closest('.variant-input'))
            $item.closest('.variant-input').classList.toggle('visually-hidden', matching_variants.length == 0);  
          }
        });

        // select any non-selected values
        am.$el.querySelectorAll('.variant-wrapper').forEach(($option) => {
          let $available_option_selected = $option.querySelector('.variant-input:not(.visually-hidden) input:checked');
          if (!$available_option_selected) {
            let $first_value = $option.querySelectorAll('.variant-input:not(.visually-hidden)')[0];
            // console.log($first_value, $first_value.querySelector('input'))
            if ($first_value) {
              $first_value.querySelector('input').checked = true;
              $first_value.querySelector('input').dispatchEvent(new Event('change', {bubbles: true}));
            }
          }
        });
      },
      e_OptionValueChanged() {
        let am = this;
        // update selected values and note
        am.$el.querySelectorAll('.variant-wrapper').forEach(($option) => {
          var note = $option.querySelector('.note');
          if(note){
            note.textContent =  $option.querySelector('input:checked').getAttribute('data-info');
          }
          $option.querySelector('.variant__label-info span').textContent = $option.querySelector('input:checked').value;
        });
  
      }
    }));
  });


/// updated FAQ
window.onload = function () {
  console.log('loading faq script');

  // Get references to elements
  const searchInput = document.getElementById('fillSearch');
  const container = document.querySelector('.faq-index-wrap');
  const articles = Array.from(document.querySelectorAll('.faq-article'));

  // Build an array of searchable data
  const searchableData = articles.map((article) => {
    return {
      title: article.querySelector('.title h5').innerText,
      category: article.dataset.category,
      id: article.id,
    };
  });

  // Function to filter and display search results
  const showSearchResults = (query) => {
    const resultsDropdown = document.querySelector('.ui-autocomplete');
    resultsDropdown.innerHTML = ''; // Clear previous results

    if (!query) {
      resultsDropdown.style.display = 'none';
      return;
    }

    // Filter articles based on the query
    const filteredResults = searchableData.filter((item) =>
      item.title.toLowerCase().includes(query.toLowerCase())
    );

    if (filteredResults.length === 0) {
      resultsDropdown.innerHTML = `<div>No results found</div>`;
      resultsDropdown.style.display = 'block';
      return;
    }

    filteredResults.forEach((item) => {
      const resultItem = document.createElement('div');
      resultItem.classList.add('result-item');
      resultItem.textContent = item.title;
      resultItem.dataset.url = `#${item.id}`;
      resultItem.dataset.category = item.category;

      // Add click event to navigate to the article
      resultItem.addEventListener('click', () => {
        navigateToArticle(item.category, item.id);
      });

      resultsDropdown.appendChild(resultItem);
    });

    resultsDropdown.style.display = 'block';
  };

  // Navigate to the article and show it
  const navigateToArticle = (category, id) => {
    // Update visible articles
    articles.forEach((article) => {
      article.classList.toggle('visible', article.id === id);
    });

    // Update category active state
    document.querySelectorAll('.faq-cat').forEach((cat) => {
      cat.classList.toggle('active', cat.dataset.category === category);
    });

    // Scroll to the article
    const targetArticle = document.getElementById(id);
    if (targetArticle) {
      window.scrollTo({
        top: targetArticle.offsetTop - 116,
        behavior: 'smooth',
      });
    }

    // Clear search input and results
    searchInput.value = '';
    document.querySelector('.ui-autocomplete').style.display = 'none';
  };

  // Event listener for search input
  searchInput.addEventListener('input', (e) => {
    showSearchResults(e.target.value);
  });

  // Initial category visibility setup
  const activeCategory = document.querySelector('.faq-cat.active')?.dataset.category;
  articles.forEach((article) => {
    article.classList.toggle('visible', article.dataset.category === activeCategory);
  });

  // Category button click handling
  document.querySelectorAll('.faq-cat').forEach((cat) => {
    cat.addEventListener('click', (e) => {
      e.preventDefault();
      const category = cat.dataset.category;

      // Update visible articles
      articles.forEach((article) => {
        article.classList.toggle('visible', article.dataset.category === category);
      });

      // Update category active state
      document.querySelectorAll('.faq-cat').forEach((catItem) => {
        catItem.classList.toggle('active', catItem === cat);
      });

      // Update URL hash
      window.location.hash = category;
    });
  });

  // Handle collapsible FAQ articles
  document.querySelectorAll('.faq-article .title').forEach((title) => {
    title.addEventListener('click', () => {
      title.parentElement.classList.toggle('open');
    });
  });
};

